(() => {
  'use strict';
  const key = '__anernVideoCenterModalV3';
  if (window[key]) return;
  const controller = new AbortController();
  const options = { signal: controller.signal };
  const scope = '.anern-video-center-page';
  const state = { dialog: null, trigger: null, locked: false, overflow: '', priority: '' };
  window[key] = { controller, state };
  function track(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: name, ...detail });
  }
  function videoId(href) {
    try {
      const url = new URL(href, location.href);
      if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
      const host = url.hostname.toLowerCase();
      let id;
      if (host === 'youtu.be') id = url.pathname.split('/')[1];
      else if (['youtube.com', 'www.youtube.com', 'm.youtube.com', 'youtube-nocookie.com', 'www.youtube-nocookie.com'].includes(host)) {
        id = url.searchParams.get('v');
        if (!id && /^\/(embed|shorts|live)\//.test(url.pathname)) id = url.pathname.split('/')[2];
      }
      return /^[A-Za-z0-9_-]{11}$/.test(id || '') ? id : null;
    } catch { return null; }
  }
  function lockScroll() {
    if (state.locked) return;
    state.overflow = document.documentElement.style.getPropertyValue('overflow');
    state.priority = document.documentElement.style.getPropertyPriority('overflow');
    document.documentElement.style.setProperty('overflow', 'hidden');
    state.locked = true;
  }
  function release(focus = true) {
    const dialog = state.dialog;
    if (dialog) dialog.querySelector('.anern-video-center-video-player-slot')?.replaceChildren();
    if (state.locked) {
      if (state.overflow) document.documentElement.style.setProperty('overflow', state.overflow, state.priority);
      else document.documentElement.style.removeProperty('overflow');
      state.locked = false;
    }
    const trigger = state.trigger;
    state.dialog = null;
    state.trigger = null;
    if (focus && trigger?.isConnected) trigger.focus({ preventScroll: true });
  }
  function close(focus = true) {
    const dialog = state.dialog;
    release(focus);
    if (dialog?.open) dialog.close();
  }
  function refresh() {
    document.querySelectorAll(scope).forEach(root => {
      const dialog = root.querySelector('dialog.anern-video-center-video-dialog');
      root.querySelectorAll('a[data-video-id]').forEach(link => {
        if (dialog) link.setAttribute('aria-controls', dialog.id);
      });
    });
  }
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const root = event.target.closest(scope);
    if (!root) return;
    const currentDialog = event.target.closest('dialog.anern-video-center-video-dialog');
    if (currentDialog && event.target === currentDialog) {
      const r = currentDialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close();
      return;
    }
    if (event.target.closest('.anern-video-center-video-dialog-close')) {
      event.preventDefault();
      close();
      return;
    }
    const link = event.target.closest('a');
    if (!link) return;
    if (link.getAttribute('aria-disabled') === 'true') {
      event.preventDefault();
      return;
    }
    if (link.matches('.anern-video-center-video-dialog-external')) {
      track('video_link_click', { destination: link.href, button_position: 'video_modal' });
      close();
      return;
    }
    if (link.matches('.anern-video-center-video-contact')) {
      track('support_cta_click', { page_name: 'Video Center', button_position: 'bottom_support', destination: link.href });
      return;
    }
    if (!link.matches('a[data-video-id]') || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const dialog = root.querySelector('dialog.anern-video-center-video-dialog');
    const id = videoId(link.href);
    if (!dialog || typeof dialog.showModal !== 'function' || !id) return;
    const slot = dialog.querySelector('.anern-video-center-video-player-slot');
    const heading = dialog.querySelector('.anern-video-center-video-dialog-header h2');
    const external = dialog.querySelector('.anern-video-center-video-dialog-external');
    if (!slot || !heading || !external) return;
    event.preventDefault();
    if (state.dialog && state.dialog !== dialog) close(false);
    state.dialog = dialog;
    state.trigger = link;
    const title = link.closest('.anern-video-center-video-card')?.querySelector('h3')?.textContent || heading.textContent;
    heading.textContent = title;
    external.href = link.href;
    const frame = document.createElement('iframe');
    frame.title = title + ' — YouTube video player';
    frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    frame.allowFullscreen = true;
    frame.referrerPolicy = 'strict-origin-when-cross-origin';
    frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&playsinline=1&rel=0';
    slot.replaceChildren(frame);
    try {
      if (!dialog.open) dialog.showModal();
    } catch {
      release(false);
      window.open(link.href, '_blank', 'noopener');
      return;
    }
    lockScroll();
    track('video_modal_open', { video_id: link.dataset.videoId, category: link.dataset.category, destination: link.href });
  }, options);
  document.addEventListener('cancel', event => {
    if (event.target === state.dialog) {
      event.preventDefault();
      close();
    }
  }, { ...options, capture: true });
  document.addEventListener('close', event => {
    if (event.target === state.dialog && !event.target.open) release();
  }, { ...options, capture: true });
  document.addEventListener('shopify:section:load', () => {
    if (state.dialog && !state.dialog.isConnected) close(false);
    refresh();
  }, options);
  document.addEventListener('shopify:section:unload', event => {
    const target = event.target;
    if (state.dialog && (!state.dialog.isConnected || (target instanceof Element && (target.contains(state.dialog) || target.contains(state.trigger))))) close(false);
  }, options);
  document.addEventListener('shopify:block:select', event => {
    if (event.target instanceof Element && event.target.closest(scope)) {
      close(false);
      event.target.scrollIntoView({ block: 'nearest' });
    }
  }, options);
  document.addEventListener('shopify:block:deselect', () => {}, options);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true, signal: controller.signal });
  else refresh();
})();
